/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SavedInputs */

const en_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const es_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado`)
};

const fr_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré`)
};

const de_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

const ja_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存済み`)
};

const zh_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已保存`)
};

const ar_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الحفظ`)
};

const id_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersimpan`)
};

const it_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvato`)
};

const ru_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранено`)
};

const pt_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado`)
};

const ko_saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장됨`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {SavedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const saved = /** @type {((inputs?: SavedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SavedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saved(inputs)
	if (locale === "es") return es_saved(inputs)
	if (locale === "fr") return fr_saved(inputs)
	if (locale === "de") return de_saved(inputs)
	if (locale === "ja") return ja_saved(inputs)
	if (locale === "zh") return zh_saved(inputs)
	if (locale === "ar") return ar_saved(inputs)
	if (locale === "id") return id_saved(inputs)
	if (locale === "it") return it_saved(inputs)
	if (locale === "ru") return ru_saved(inputs)
	if (locale === "pt") return pt_saved(inputs)
	return ko_saved(inputs)
});